<template>
    <div>
        <Spin fix v-show="isSpinShow">
            <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
        <Table id="selectionTable" ref="selectionTable" :max-height="height" :data="showData" :columns="showColumns"
            stripe highlight-row border @on-current-change="onSelectionTableChange"></Table>
        <Row style="padding:10px 0px 0px 0px">
            <Col span="3" style="padding:0px 5px 0px 0px">
            <Button :disabled="!isAdmin" long type="success" @click="onClickInsert">添加{{typeName}}</Button>
            </Col>
            <Col span="3" style="padding:0px 5px 0px 0px">
            <Button :disabled="!isAdmin" long type="warning" @click="onClickUpdate">修改{{typeName}}</Button>
            </Col>
            <Col span="3" style="padding:0px 5px 0px 0px">
            <Button :disabled="!isAdmin" long type="error" @click="onClickDelete">删除{{typeName}}</Button>
            </Col>
            <Col span="3" style="padding:0px 5px 0px 0px">
            <Button :disabled="!isAdmin" long type="primary" @click="onClickBind">绑定权限</Button>
            </Col>
            <Col span="3" style="padding:0px 5px 0px 0px">
            <Button long type="primary" @click="onClickAllocation">分配{{typeName}}</Button>
            </Col>
            <Col span="9">
            <Page :current="currentPage" :total="dataCount" :page-size="pageSize" show-sizer show-total @on-change="changePage"
                @on-page-size-change="changePageSize" style="text-align:right"></Page>
            </Col>
        </Row>

        <!-- 模态框insert -->
        <Modal v-model="isShowInsertModal" :mask-closable="false" width="380">
            <p slot="header" style="color:#19be6b;text-align:center">
                <Icon type="md-create" />
                <span>添加{{typeName}}</span>
            </p>
            <Form ref="formInsert" :label-width="110" :rules="ruleInsert" :model="formInsert">
                <FormItem prop="roleName" label="角色名称：">
                    <Input v-model="formInsert.roleName" placeholder="请输入角色名称..."></Input>
                </FormItem>
                <FormItem prop="roleRemark" label="角色备注：">
                    <Input v-model="formInsert.roleRemark" placeholder="请输入角色备注..."></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="success" size="large" long :loading="isLoadingButton" @click="commitInsert">添加</Button>
            </div>
        </Modal>

        <!-- 模态框update -->
        <Modal v-model="isShowUpdateModal" :mask-closable="false" width="380">
            <p slot="header" style="color:#ff9900;text-align:center">
                <Icon type="md-create" />
                <span>修改{{typeName}}</span>
            </p>
            <Form ref="formUpdate" :label-width="110" :rules="ruleInsert" :model="formUpdate">
                <FormItem prop="roleName" label="角色名称：">
                    <Input v-model="formUpdate.roleName" placeholder="请输入角色名称..."></Input>
                </FormItem>
                <FormItem prop="roleRemark" label="角色备注：">
                    <Input v-model="formUpdate.roleRemark" placeholder="请输入角色备注..."></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="warning" size="large" long :loading="isLoadingButton" @click="commitUpdate">修改</Button>
            </div>
        </Modal>

        <!-- 模态框delete -->
        <Modal v-model="isShowDeleteModal" :mask-closable="false" width="380">
            <p slot="header" style="color:#ed4014;text-align:center">
                <Icon type="md-create" />
                <span>删除{{typeName}}</span>
            </p>
            <div style="color:#ed4014;text-align:center">是否确认删除所选{{typeName}}？</div>
            <div slot="footer">
                <Button type="error" size="large" long :loading="isLoadingButton" @click="commitDelete">删除</Button>
            </div>
        </Modal>

        <!-- 模态框bind -->
        <Modal v-model="isShowBindModal" :mask-closable="false" width="600">
            <p slot="header" style="color:#2d8cf0;text-align:center">
                <Icon type="md-create" />
                <span>绑定权限</span>
            </p>
            <div style="color:#2d8cf0;text-align:center">
                <Spin fix v-show="isBindSpinShow">
                    <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
                    <div>Loading</div>
                </Spin>
                <Transfer v-if=isShowBindModal :data="transferData" :target-keys="targetKeys" :render-format="renderFormat" @on-change="transferChange"
                    :titles="['未绑定权限', '绑定的权限']" :list-style="listStyle" :selected-keys="roleSelected"></Transfer>
            </div>
            <div slot="footer">
                <Button type="primary" size="large" long :loading="isLoadingButton" @click="commitBind">绑定</Button>
            </div>
        </Modal>

        <!-- 模态框bind -->
        <Modal v-model="isShowAllocationModal" :mask-closable="false" width="600">
            <p slot="header" style="color:#2d8cf0;text-align:center">
                <Icon type="md-create" />
                <span>绑定角色</span>
            </p>
            <div style="color:#2d8cf0;text-align:center">
                <Spin fix v-show="isAllocationSpinShow">
                    <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
                    <div>Loading</div>
                </Spin>
                <Table id="selectionTable" ref="selectionTable" :max-height="heightPersonnel" :data="showPersonnelData"
                    :columns="showPersonnelColumns" stripe highlight-row border @on-current-change="onSelectionPersonnelTableChange"></Table>
                <Page :current="currentPersonnelPage" :total="dataPersonnelCount" :page-size="pagePersonnelSize"
                    show-sizer show-total @on-change="changePersonnelPage" @on-page-size-change="changePersonnelPageSize"
                    style="text-align:right"></Page>
            </div>
            <div slot="footer">
                <Button type="primary" size="large" long :loading="isLoadingButton" @click="commitAllocation">绑定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    export default {
        mounted() {
            this.showColumns = [{
                    title: "id",
                    key: "roleId"
                },
                {
                    title: "角色名称",
                    key: "roleName"
                },
                {
                    title: "角色备注",
                    key: "roleRemark"
                },
                {
                    title: "创建时间",
                    key: "roleCreatetime",
                    render: function(h, params) {
                        return h(
                            "div",
                            global.dateFtt(
                                "yyyy-MM-dd hh:mm:ss",
                                new Date(this.row.roleCreatetime)
                            )
                        );
                    }
                }
            ];
            this.showPage();

            this.isAdmin = localStorage.getItem("isAdmin");
        },
        data() {
            const validateyyyy = (rule, value, callback) => {
                if (value.length === 0) {
                    callback(new Error("请输入yyyy..."));
                } else {
                    callback();
                }
            };
            return {
                roleSelected: [],
                isAdmin: true,
                typeName: "角色",
                urlClass: "role",
                height: window.innerHeight,
                heightPersonnel: 500,
                isBindSpinShow: false,
                isAllocationSpinShow: false,
                isLoadingButton: false,
                isShowInsertModal: false,
                isShowUpdateModal: false,
                isShowDeleteModal: false,
                isShowBindModal: false,
                isShowAllocationModal: false,
                isShowTarget: false,
                isSpinShow: false,
                currentPage: 1,
                dataCount: 0,
                pageSize: 10,
                showData: [],
                showColumns: [],
                selectedData: null,
                dataPersonnelCount: 0,
                showPersonnelData: [],
                showPersonnelColumns: [],
                currentPersonnelPage: 1,
                pagePersonnelSize: 10,
                selectedPersonnelData: null,
                transferData: [],
                targetKeys: [],
                originKeys: [],
                listStyle: {
                    width: "250px",
                    height: "300px",
                    textAlign: "left"
                },
                formInsert: {
                    roleName: "",
                    roleRemark: ""
                },
                formUpdate: {
                    roleName: "",
                    roleRemark: ""
                },
                ruleInsert: {
                    roleName: [{
                        required: true,
                        message: "请输入角色名称...",
                        trigger: "blur"
                    }]
                }
            };
        },
        methods: {
            onSelectionTableChange(currentRow) {
                this.selectedData = currentRow;
            },
            onSelectionPersonnelTableChange(currentRow) {
                this.selectedPersonnelData = currentRow;
            },
            onClickInsert() {
                this.isShowInsertModal = true;
            },
            onClickUpdate() {
                if (this.selectedData) {
                    this.formUpdate = this.selectedData;
                    this.isShowUpdateModal = true;
                } else {
                    this.$Notice.warning({
                        title: "警告",
                        desc: "请选择一条数据！"
                    });
                }
            },
            onClickDelete() {
                if (this.selectedData) {
                    this.isShowDeleteModal = true;
                } else {
                    this.$Notice.warning({
                        title: "警告",
                        desc: "请选择一条数据！"
                    });
                }
            },
            onClickBind() {
                let that = this;
                if (that.selectedData) {
                    that.isShowBindModal = true;
                    that.isLoadingButton = true;
                    that.isBindSpinShow = true;
                    that.transferData = [];
                    that.targetKeys = [];
                    that.originKeys = [];
                    that.roleSelected = [];
                    $.ajax({
                        url: "/api/" + that.urlClass + "/selectPermission",
                        contentType: "application/json",
                        type: "post",
                        data: JSON.stringify(that.selectedData),
                        dataType: "json",
                        success: function(data) {
                            if (data.errorCode != 0) {
                                that.$Notice.error({
                                    title: "异常",
                                    desc: data.errorInfo
                                });
                                return;
                            }
                            data.body.map(item => {
                                that.transferData.push({
                                    key: item.permissionId,
                                    label: item.permissionRemark,
                                    disabled: false
                                });
                                if (item.roleId) {
                                    that.targetKeys.push(item.permissionId);
                                    that.originKeys.push(item.permissionId);
                                }
                            });
                        },
                        error: function(textStatus) {
                            that.$Notice.error({
                                title: "异常",
                                desc: "接口请求异常"
                            });
                        },
                        complete: function() {
                            that.isLoadingButton = false;
                            that.isBindSpinShow = false;
                        }
                    });
                } else {
                    this.$Notice.warning({
                        title: "警告",
                        desc: "请选择一条数据！"
                    });
                }
            },
            onClickAllocation() {
                let that = this;
                if (that.selectedData) {
                    that.showPersonnelPage();
                } else {
                    that.$Notice.warning({
                        title: "警告",
                        desc: "请选择一条数据！"
                    });
                }
            },
            showPersonnelPage() {
                let that = this;
                that.isShowAllocationModal = true;
                that.isLoadingButton = true;
                that.isAllocationSpinShow = true;
                that.selectedPersonnelData = null;
                that.showPersonnelColumns = [{
                        title: "用户账号",
                        key: "userAccount"
                    },
                    {
                        title: "用户姓名",
                        key: "personnelName"
                    },
                    {
                        title: "角色名称",
                        key: "roleName"
                    }
                ];
                that.showPersonnelData = [];
                $.ajax({
                    url: "/api/" +
                        that.urlClass +
                        "/allocationRole?page=" +
                        that.currentPersonnelPage +
                        "&pageAmount=" +
                        that.pagePersonnelSize,
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify({}),
                    dataType: "json",
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            return;
                        }
                        that.showPersonnelData = data.body.resultList;
                        that.dataPersonnelCount = data.body.amount;
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    },
                    complete: function() {
                        that.isLoadingButton = false;
                        that.isAllocationSpinShow = false;
                    }
                });
            },
            changePersonnelPage(index) {
                this.currentPersonnelPage = index;
                this.showPersonnelPage();
            },
            changePersonnelPageSize(size) {
                this.pagePersonnelSize = size;
                this.showPersonnelPage();
            },
            commitInsert() {
                let that = this;
                that.$refs["formInsert"].validate(valid => {
                    if (valid) {
                        that.isLoadingButton = true;
                        $.ajax({
                            url: "/api/" + that.urlClass + "/insert",
                            contentType: "application/json",
                            type: "post",
                            data: JSON.stringify(that.formInsert),
                            dataType: "json",
                            success: function(data) {
                                if (data.errorCode != 0) {
                                    that.$Notice.error({
                                        title: "异常",
                                        desc: data.errorInfo
                                    });
                                    return;
                                }
                                that.showPage();
                            },
                            error: function(textStatus) {
                                that.$Notice.error({
                                    title: "异常",
                                    desc: "接口请求异常"
                                });
                            },
                            complete: function() {
                                that.isLoadingButton = false;
                                that.isShowInsertModal = false;
                            }
                        });
                    }
                });
            },
            commitUpdate() {
                let that = this;
                that.$refs["formUpdate"].validate(valid => {
                    if (valid) {
                        that.isLoadingButton = true;
                        $.ajax({
                            url: "/api/" + that.urlClass + "/update",
                            contentType: "application/json",
                            type: "post",
                            data: JSON.stringify(that.formUpdate),
                            dataType: "json",
                            success: function(data) {
                                if (data.errorCode != 0) {
                                    that.$Notice.error({
                                        title: "异常",
                                        desc: data.errorInfo
                                    });
                                    return;
                                }
                                that.showPage();
                            },
                            error: function(textStatus) {
                                that.$Notice.error({
                                    title: "异常",
                                    desc: "接口请求异常"
                                });
                            },
                            complete: function() {
                                that.isLoadingButton = false;
                                that.isShowUpdateModal = false;
                            }
                        });
                    }
                });
            },
            commitDelete() {
                let that = this;
                that.isLoadingButton = true;
                $.ajax({
                    url: "/api/" + that.urlClass + "/delete",
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify(that.selectedData),
                    dataType: "json",
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            return;
                        }
                        that.showPage();
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    },
                    complete: function() {
                        that.isLoadingButton = false;
                        that.isShowDeleteModal = false;
                    }
                });
            },
            renderFormat(item) {
                return item.label;
            },
            transferChange(newTargetKeys) {
                this.targetKeys = newTargetKeys;
            },
            commitBind() {
                if (JSON.stringify(this.originKeys) === JSON.stringify(this.targetKeys)) {
                    this.$Notice.warning({
                        title: "警告",
                        desc: "未更改任何权限！"
                    });
                } else {
                    let that = this;
                    that.isLoadingButton = true;
                    $.ajax({
                        url: "/api/" + that.urlClass + "/bindPermission",
                        contentType: "application/json",
                        type: "post",
                        data: JSON.stringify({
                            roleId: that.selectedData.roleId,
                            targetKeys: that.targetKeys
                        }),
                        dataType: "json",
                        success: function(data) {
                            if (data.errorCode != 0) {
                                that.$Notice.error({
                                    title: "异常",
                                    desc: data.errorInfo
                                });
                                return;
                            }
                            that.$Notice.success({
                                title: "成功",
                                desc: "绑定成功！"
                            });
                            that.showPage();
                        },
                        error: function(textStatus) {
                            that.$Notice.error({
                                title: "异常",
                                desc: "接口请求异常"
                            });
                        },
                        complete: function() {
                            that.isLoadingButton = false;
                            that.isShowBindModal = false;
                        }
                    });
                }
            },
            commitAllocation() {
                if (this.selectedPersonnelData) {
                    let that = this;
                    that.isLoadingButton = true;
                    $.ajax({
                        url: "/api/" + that.urlClass + "/allocation",
                        contentType: "application/json",
                        type: "post",
                        data: JSON.stringify({
                            userId: that.selectedPersonnelData.userId,
                            roleId: that.selectedData.roleId
                        }),
                        dataType: "json",
                        success: function(data) {
                            if (data.errorCode != 0) {
                                that.$Notice.error({
                                    title: "异常",
                                    desc: data.errorInfo
                                });
                                return;
                            }
                            that.$Notice.success({
                                title: "成功",
                                desc: "分配成功！"
                            });
                            that.showPersonnelPage();
                        },
                        error: function(textStatus) {
                            that.$Notice.error({
                                title: "异常",
                                desc: "接口请求异常"
                            });
                        },
                        complete: function() {
                            that.isLoadingButton = false;
                        }
                    });
                } else {
                    this.$Notice.warning({
                        title: "警告",
                        desc: "请选择一条数据！"
                    });
                }
            },
            showPage() {
                let that = this;
                that.isSpinShow = true;
                that.selectedData = null;
                $.ajax({
                    url: "/api/" +
                        that.urlClass +
                        "/selectPage?page=" +
                        that.currentPage +
                        "&pageAmount=" +
                        that.pageSize,
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify({}),
                    dataType: "json",
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            return;
                        } else {
                            that.showData = data.body.resultList;
                            that.dataCount = data.body.amount;
                        }
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    },
                    complete: function() {
                        that.isSpinShow = false;
                    }
                });
            },
            changePage(index) {
                this.currentPage = index;
                this.showPage();
            },
            changePageSize(size) {
                this.pageSize = size;
                this.showPage();
            }
        }
    };
</script>

<style>
    #selectionTable /deep/.ivu-table td,
    #selectionTable /deep/.ivu-table th {
        min-width: 0;
        height: 40px;
        box-sizing: border-box;
        text-align: center;
        text-overflow: ellipsis;
        vertical-align: middle;
        border-bottom: 1px solid #e8eaec;
    }
</style>
